
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router'
import { Box, Button, Chip, IconButton, InputAdornment, Skeleton, Stack, TextField, Typography } from '@mui/material'
import InfiniteScroll from 'react-infinite-scroll-component'
import { FilterIcon, SearchIcon } from '../../assets/CommonSvg'
import OperationalCard from '../../components/common/OperationalCard'
import BsModal from '../../components/common/BaseModal'
import AddTemplateForm from './addTemplateForm'
import PopoverDialog from '../../components/common/PopoverDialog'
import Filter from './Filter'
import NoDataCard from '../../components/NoDataCard'
import { deleteTemplate, disableModal, enableModal, fetchAllVersions, fetchTemplates, isTemplateModal, templateDropdown, templateExist } from '../../slices/formTemplate'
import DeleteModal from '../../components/common/BaseModal/DeleteModal'
import { notify } from '../../utils/methods/notification'
// import { ConfirmationInfoIcon } from '../../../assets/common-svg/CommonSvg'

const TemplateManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [openModal, setOpenModal] = useState(false)
  const [existenceData, setExistenceData] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null);
  const [filters, setFilters] = useState({ status: [], versions: [] });
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(false)
  const addModal = useSelector(isTemplateModal);

  const handleCloseModal = async () => {
    await dispatch(disableModal());
    };

  const { items, pagination } = useSelector((state) => state.bmrFbl.fbTemplate);
  const openTemplateModal = async () => {
    const response = await dispatch(templateExist());
    setExistenceData(response?.payload?.data)
    let isTemplateExists = response?.payload?.data?.templateExists
    if (isTemplateExists) {
      setOpenModal(true)
    } else {
      await dispatch(enableModal());
      }
  };

  const handleAccept = async () => {
    await handleViewDetail(existenceData.templateId)
    setOpenModal(false)
  }
  const handleRejection = async () => {
    try {
      await dispatch(deleteTemplate(existenceData.templateId))
      await dispatch(fetchTemplates())
      setOpenModal(false)
    } catch (error) {
      notify.error(error?.message || error?.data?.message)
    }
  }

  const handleFilterClick = (event) => setAnchorEl(event.currentTarget);
  const handleFilterClose = () => setAnchorEl(null);
  const handleFilterApply = (params) => {
    setFilters(params);
    handleFilterClose();
  };

  const handleFilterClear = (params) => {
    setFilters(params);
    handleFilterClose();
  };

  const handleViewDetail = async (id) => {
    try {
      navigate(`/bmr/form-management/${id}`, {
        state: [
          { name: "Form Management", path: location.pathname },
          {
            name: "Template",
            path: `/bmr/form-management/${id}`,
          },
        ],
      })
    } catch (error) {
      console.error(error) //@info setting data here.
    }
  }

  //@info fetch all over version and transform to send in filters.
  const handleFetchVersions = async () => {
    const result = await dispatch(fetchAllVersions()).unwrap();
    
    const maxVersion = result.data?.max_version;
    const versionOptions = Array.from({ length: maxVersion }, (_, index) => {
      const versionNumber = index + 1;
      return {
        label: `V.${versionNumber}`,
        value: versionNumber
      };
    });

    setVersions(versionOptions);
  }

  useEffect(() => {
    handleFetchVersions()
    dispatch(templateDropdown())
  }, []);
  
const fetchMoreData = async () => {
  if (pagination.page < pagination.total_pages) {

    const params = {
      page: pagination.page + 1,
      per_page: pagination.per_page,
      search: searchTerm ||null,
      // sort_by:"created_at",  //@info optional filter method may be added later
      status: filters?.status?.length ? filters.status.join(",") :null,
      version: filters?.versions?.length ? filters.versions.join(",") :null,
    };

    await dispatch(fetchTemplates(params));
  }
};
  const handleRemoveFilterFromChip = (chipToDelete) => {
    const updatedFilters = { ...filters };
    if (Array.isArray(updatedFilters[chipToDelete.key])) {
      updatedFilters[chipToDelete.key] = updatedFilters[chipToDelete.key].filter(val => val !== chipToDelete.value);
      if (updatedFilters[chipToDelete.key].length === 0) delete updatedFilters[chipToDelete.key];
    } else {
      delete updatedFilters[chipToDelete.key];
    }
    setFilters(updatedFilters);
  };

const handleFetchTemplates = async (page = 1) => {
  try {
    setLoading(true);

    const params = {
      page,
      per_page: 12,
      search: searchTerm || null,
      // sort_by:"created_at", //@info optional filter method may be added later
      status: filters?.status?.length ? filters.status.join(",") : null,
      version: filters?.versions?.length ? filters.versions.join(",") : null,
    };

    await dispatch(fetchTemplates(params));
  } finally {
    setLoading(false);
  }
};


  const getFilterChips = (filters, filterConfig) => {
    const chips = [];
    if (!filters) return chips;
    Object.entries(filters).forEach(([key, value]) => {
      const config = filterConfig[key];

      if (value) {
        if (Array.isArray(value)) {
          value.forEach(val => {
            let label;
            if (key === 'versions' && config?.enum?.[val]) {
              label = config.enum[val];
            } else {
              label = config?.enum?.[val] || val;
            }
            
            chips.push({ 
              key, 
              value: val, 
              filterLabel: config?.label, 
              filterValLabel: label 
            });
          });
        } else {
          let label;
          if (key === 'versions' && config?.enum?.[value]) {
            label = config.enum[value];
          } else {
            label = config?.enum?.[value] || value;
          }
          
          chips.push({ 
            key, 
            value, 
            filterLabel: config?.label, 
            filterValLabel: label 
          });
        }
      }
    });
    return chips;
  };
   const handleClearAllFilters = () => {
    setFilters(null);
  };
   const filterConfigStatusVersion = {
    status: {
      label: "Status",
      enum: {
        0: "Pending",
        1: "Submitted", 
        2: "Published",
        3: "Draft"
      }
    },
    versions: {
      label: "Version",
      enum: versions.reduce((acc, version) => {
        acc[version.value] = version.label; 
        return acc;
      }, {})
    }
  };

  useEffect(() => {
    handleFetchTemplates()
  }, [searchTerm, filters]);

    const filterChips = useMemo(() => getFilterChips(filters, filterConfigStatusVersion), [filters, filterConfigStatusVersion, versions]);

  return (
    <div className='bg-white m-4 p-4 rounded-2xl min-h-screen'>
      <div className='flex justify-between mb-4'>
        <Typography variant="h4" sx={{ fontSize: 18 }}>
          Templates (
          {filterChips?.length > 0
            ? items?.length || 0
            : pagination?.total || 0}
          )
        </Typography>

        <div className='flex justify-end gap-3'>
          <TextField
            className="bg-[#F0F1F5] w-[325px] border-0 rounded-[10px]"
            size="small"
            placeholder="Search here"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon className="text-gray-500" />
                </InputAdornment>
              ),
            }}
            sx={{
              backgroundColor: "white",
              color: "black",
              "& .MuiInputBase-root": {
                height: "45px",
                display: "flex",
                alignItems: "center", 
                borderRadius: "0.75rem",
                padding: "0 10px", 
              },
              "& input::placeholder": {
                color: "#777777",
                opacity: 1,
              },
              "& fieldset": { border: "none" },
            }}
          />
          <Button onClick={openTemplateModal} className='w-auto'> Create New Template</Button>
          <Stack>
            <IconButton
              disableRipple
              aria-label="filter"
              className="bg-gray-200 h-[44px] w-10 rounded-[10px]"
              onClick={handleFilterClick}
            >
              <FilterIcon />
            </IconButton>
            <PopoverDialog
              title="Filter"
              anchorEl={anchorEl}
              onClose={handleFilterClose}
            >
              <Filter onApply={handleFilterApply} onClear={handleFilterClear} initialFilters={filters} versions={versions} />
            </PopoverDialog>
          </Stack>
        </div>
      </div>
      <Box>
        {filterChips.length > 0 && (
          <Box mt={2} mb={1} display="flex" flexWrap="wrap" gap={1}>
            {filterChips.map((chip, idx) =>
            (
              <Chip
                key={`${chip.key}-${chip.value}-${idx}`}
                className="!bg-[#F0F1F5]"
                label={
                  <span className='font-roboto font-normal text-[13px] leading-[100%]'>
                    <span className='!text-[#828282]'>{chip.filterLabel}:</span>{' '}
                    <span className='!text-black'>{chip.filterValLabel}</span>
                  </span>
                }
                onDelete={() => handleRemoveFilterFromChip(chip)}
              />
            ))}
            <Chip
              label="Clear All"
              onClick={handleClearAllFilters}
              className="!bg-[#3571FF] !text-[#ffffff] hover:!bg-[#171928] font-roboto font-medium text-[13px] leading-[100%] tracking-[0]"
            />
          </Box>
        )}
      </Box>

      {loading && pagination.page === 1 ? (
        <Box
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(min(300px, 100%), 1fr))",
            gap: 2,
            p: 2,
          }}
        >
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} variant="rounded" height={180} sx={{ borderRadius: 2 }} />
          ))}
        </Box>
      ) : (
        <InfiniteScroll
          dataLength={items.length}
          next={fetchMoreData}
          hasMore={pagination.page < pagination.total_pages}
          loader={
            (loading && pagination.page > 1 && <Box
              sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(min(300px, 100%), 1fr))",
                gap: 2,
                p: 2,
              }}
            >
              {[...Array(2)].map((_, i) => (
                <Skeleton key={i} variant="rounded" height={180} sx={{ borderRadius: 2 }} />
              ))}
            </Box>)
          }
        >
          {items.length > 0 ? (
            <OperationalCard data={items} handleViewDetail={handleViewDetail} />
          ) : (
            !loading && (
              <div className="mt-4 border rounded-2xl">
                <NoDataCard />
              </div>
            )
          )}
        </InfiniteScroll>
      )}

      <BsModal open={addModal} onClose={handleCloseModal} title="Create Form Template">
        <AddTemplateForm />
      </BsModal>

      <DeleteModal  
        open={openModal}
        setClose={setOpenModal}
        title="An existing template is already present. Do you want to proceed with existing template?"
        buttonText="Yes"
        fontWeight={300}
        handleSuccess={handleAccept}
        handleRejection={handleRejection}
        rejectButtonText="No"
      />
    </div>
  );
};

export default TemplateManagement;
